import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0ebf07db"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "Files", -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Delete")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Edit ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Remove")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_EditOutlined = _resolveComponent("EditOutlined")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_Form = _resolveComponent("Form")!
  const _component_loader = _resolveComponent("loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_row, { class: "section" }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, { span: 20 }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          span: 4,
          class: "edit-icon-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_EditOutlined, {
              style: {"cursor":"pointer","display":"flex","justify-content":"flex-end","font-size":"25px"},
              onClick: _ctx.create
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_a_table, {
      "row-key": "id",
      size: "small",
      columns: _ctx.columns,
      "data-source": _ctx.invoice.invoice_files,
      bordered: "",
      style: {"overflow-x":"auto","overflow-y":"auto"}
    }, {
      action: _withCtx(({ record }) => [
        (_ctx.isNew == false)
          ? (_openBlock(), _createBlock(_component_a_space, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.edit(record)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.downloadRecord(record)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_popconfirm, {
                  title: "Sure to delete?",
                  onConfirm: ($event: any) => (_ctx.deleteRecord(record))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "danger",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ]),
              _: 2
            }, 1024))
          : (_openBlock(), _createBlock(_component_a_space, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: ($event: any) => (_ctx.edit(record)),
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                _createVNode(_component_a_button, {
                  type: "danger",
                  size: "small",
                  onClick: ($event: any) => (_ctx.remove(record))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024))
      ]),
      _: 1
    }, 8, ["columns", "data-source"]),
    _createVNode(_component_Form, {
      ref: "file_form",
      title: "Invoice File"
    }, null, 512),
    _createVNode(_component_loader, {
      title: _ctx.loader_title,
      content: _ctx.loader_content,
      visible: _ctx.visible_update_modal,
      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.visible_update_modal = false))
    }, null, 8, ["title", "content", "visible"])
  ], 64))
}